import { Component, input, output } from '@angular/core';
import { IUserPaymentMethod } from '@webapp/users/interfaces/users.interface';
import { PaymentCardItemComponent } from '../payment-card-item/payment-card-item.component';
import { PaymentSkeletonItemComponent } from '../payment-skeleton-item/payment-skeleton-item.component';

@Component({
	selector: 'app-payments-list',
	standalone: true,
	imports: [PaymentSkeletonItemComponent, PaymentCardItemComponent],
	templateUrl: './payments-list.component.html',
	styleUrl: './payments-list.component.scss',
})
export class PaymentsListComponent {
	paymentMethods = input<IUserPaymentMethod[]>([]);
	loading = input<boolean>(true);
	setPaymentEvent = output<IUserPaymentMethod>();

	setPayment(payment: IUserPaymentMethod) {
		this.setPaymentEvent.emit(payment);
	}
}
